<!-- Custom dropdown component -->
<!-- Can handle submenus -->
<template lang="pug">
.vue-dropdown(@click="opened = !opened;$emit('opened', opened);" v-if="dropdown_data" )
  .hidden-overlay(v-if="opened" @click.stop="opened = false;$emit('opened', opened);")
  slot
  transition(name="fade" mode="out-in")
    .content(v-if="opened" :style="{top: $el.clientHeight + 'px'}")
      .option.row.center.left(v-for="datum, key in dropdown_data" @click.stop.prevent="select(key)" :class="{selected: value && value.includes(key)}")
        .checkbox
          .checkbox-marker.row.center
            font-awesome-icon(icon="check")
        div {{ t['status_' + datum.name] || t[datum.name] || datum.name.titleize() }}
</template>
<script>
export default {
  props: ['data', 'value'],
  data() {
    return {
      opened: false,
      selected: [],
    }
  },
  computed: {
    dropdown_data() {
      if (!this.data) return
      if (type(this.data) === 'array') return this.data.reduce((acc, v) => {
          acc[v] = {id: v, name: v}
          return acc
        }, {})
      return this.data
    }
  },
  mounted() {
    if (this.start) start.m
  },
  methods: {
    select(key) {
      const selected = this.value || []
      if (selected.includes(key)) return this.$emit('input', selected.filter(d => d!==key))
      selected.push(key)
      return this.$emit('input', selected)
    },
  },
  watch: {
    dropdown_data() {
      if (!this.dropdown_data) return
      // if (this.selected && this.dropdown_data.keys().includes(this.selected)) return this.active = this.dropdown_data[this.selected]
      // if (this.hotload && this.dropdown_data) this.select(this.dropdown_data.keys()[0])
    }
  }
}
</script>
<style scoped>
.vue-dropdown { position: relative; cursor: pointer;}
.selected, .option { padding: 6px 48px 6px 12px; width: 100%; }
.hidden-overlay {position: fixed; width: 100vw; height: 100vh; z-index: 999; top:0; left:0;}
.content { position: absolute; background: white; box-shadow: var(--box-shadow); min-width: 100%; width: fit-content; color: var(--text); z-index:1000; border-radius: 8px; overflow: hidden;}
.content .option:hover { background: rgba(0,0,0,0.1); }
.caret { fill: white; width: 16px; height: 16px;}
.checkbox { width: 16px; height: 16px; border-radius: 4px; border: 2px solid var(--text); margin-right: 6px; }
.checkbox .checkbox-marker {
  width: 100%;
  height: 100%;
  background: var(--primary-dark);
  display: none;
}
.checkbox .checkbox-marker svg {
  width: 10px;
  height: 10px;
  color: white;
}
.option.selected {
  background: var(--primary-hover);
  /* font-weight: bold; */
}
.option.selected .checkbox {
  background: var(--text);
  fill: white;
  border: 2px solid var(--primary-dark);
}
.option.selected .checkbox .checkbox-marker { display: flex; }
</style>
